import React from 'react'
import PropTypes from 'prop-types'
import ISMPIndicator from './ISMPIndicator'
import ExternalBarcodeIndicator from './ExternalBarcodeIndicator'
import SearchIndicator from './SearchIndicator'

const ScanIndicator = ({ ismpStatus, externalBarcodeIsAvailable }) => {
  let indicator

  if (ismpStatus === 'connected') {
    indicator = <ISMPIndicator />
  } else if (externalBarcodeIsAvailable) {
    indicator = <ExternalBarcodeIndicator />
  } else {
    indicator = <SearchIndicator />
  }

  return <div>{indicator}</div>
}

ScanIndicator.defaultProps = {
  externalBarcodeIsAvailable: true,
}

ScanIndicator.propTypes = {
  ismpStatus: PropTypes.string,
  externalBarcodeIsAvailable: PropTypes.bool.isRequired,
}

export default ScanIndicator
